import "./About.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Story from "./sections/Story";
import Standards from "./sections/Standards";
import Faq from "./sections/Faq";
import Work from "./sections/Work";
import Footer from "@/reusable_sections/Footer";
import RequestEstimate from "./sections/RequestEstimate";
import DecaturHousingContext from "./sections/DecaturHousingContext";
export default function AboutPage() {
  return <div>
      <Header />
      <Hero />
      <Story />
      <DecaturHousingContext />
      <Standards />
      <RequestEstimate />
      <Faq />
      <Work />
      <Footer />
    </div>;
}